module.exports = __webpack_public_path__ + "static/img/6.842ce6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/culturalCourses/6.png
// module id = 0Vva
// module chunks = 0